import React from 'react';

export const Loader = ({isFullHeight = false}) => (
    <div className={(isFullHeight) ? "d-flex justify-content-center loader" : "d-flex justify-content-center" }>          
        <div className="spinner-border" role="status">
            <span className="sr-only">...</span>
        </div>
    </div> 
);
